import React, { useMemo } from 'react';
import { InstallmentProviderType } from '../../../enums';
import PaymentIconBase, { PaymentIconSize } from '../PaymentIconBase/PaymentIconBase';

import Sber from './icons/sber.svg';
import Otp from './icons/otp.svg';
import VsegdaDa from './icons/vsegdada.svg';
import Tbank from './icons/tbank.png';
import YandexRu from './icons/yandexRu.png';
import Dolyame from './icons/dolyame.svg';
import DirectCredit from './icons/directcredit.svg';
import Freedom from './icons/freedom.svg';
import ProOnline from './icons/proonline.svg';

const p_icons: Partial<Record<InstallmentProviderType, string>> = {
    [InstallmentProviderType.Sberbank]: Sber,
    [InstallmentProviderType.Otp]: Otp,
    [InstallmentProviderType.VsegdaDa]: VsegdaDa,
    [InstallmentProviderType.Tinkoff]: Tbank,
    [InstallmentProviderType.YandexSplit]: YandexRu,
    [InstallmentProviderType.Dolyame]: Dolyame,
    [InstallmentProviderType.DirectCredit]: DirectCredit,
    [InstallmentProviderType.FreedomFinance]: Freedom,
    [InstallmentProviderType.ProOnline]: ProOnline
};

const p_wideProviders: InstallmentProviderType[] = [
    InstallmentProviderType.VsegdaDa,
    InstallmentProviderType.YandexSplit,
    InstallmentProviderType.Dolyame,
    InstallmentProviderType.FreedomFinance,
    InstallmentProviderType.ProOnline
];

export const hasInstallmentProviderIcon = (provider?: InstallmentProviderType) =>
    provider != null && p_icons[provider] != null;

type Props = {
    provider: InstallmentProviderType;
    size?: PaymentIconSize;
}

const InstallmentProviderIcon: React.FC<Props> = ({ provider, size }) => {

    const img = useMemo(() => p_icons[provider] ?? null, [provider]);

    const isWide = useMemo(() => p_wideProviders.includes(provider), [provider]);

    return <PaymentIconBase src={img} size={size} wide={isWide} />;
}

export default InstallmentProviderIcon;
